import React from "react";
import { Button, Form, Grid, Header, Segment } from "semantic-ui-react";

import vacinasService from "../services/vacinas.service";
import Loader from "./Loader";
import { showMessage } from '../helpers/helper';

const theme = {
    vacinas: {
        em_dia: "#88C99E",
        proxima_dose: "#E7CE99",
        atrasada: "#FE0100"
    }
}

export default class Vacinas extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            vacinas: []
        };
    }

    async componentDidMount() {
        this.setState({ isLoading: true }, this.loadVacinas);
    }

    loadVacinas = async () => {
        try {
            this.setState({ vacinas: await vacinasService.getDosesPacienteAsync() });
        } finally {
            this.setState({ isLoading: false });
        }
    }

    downloadCarteira = async () => {
        try {
            this.setState({ isLoading: true });
            await vacinasService.getCarteiraVacinacaoAsync();
        } finally {
            this.setState({ isLoading: false });
        }
    }

    handleCancelar = () => {
        const { history } = this.props;
        history.push('/resultados');
    };

    render() {
        const { vacinas, isLoading } = this.state;
        const dosesAplicadas = vacinas.filter(x => x.doses.some(y => y.status !== 3));
        const dosesRecomendadas = vacinas.filter(x => x.doses.some(y => y.status === 3));

        return (
            <Segment>
                <Loader isLoading={isLoading} />
                <Header as="h2">
                    <p>VACINAS</p>
                </Header>

                <div style={{ marginBottom: 20 }}>
                    {!dosesAplicadas.length ?
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{ padding: 20 }}>Não há doses registradas</span>
                        </div> :
                        <>
                            <Legend />
                            {dosesAplicadas.map(vacina =>
                                <CardContainer key={vacina.exaCod}>
                                    <div style={{ display: "flex", flexDirection: "row", alignItems: 'center', gap: 5 }}>
                                        <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                                            <span style={{ fontSize: 19 }}>{vacina.exaNome}</span>
                                            <div style={{ display: "flex", flexDirection: "row", gap: 4, flexWrap: 'wrap', marginTop: 10 }}>
                                                {vacina.doses.filter(x => x.status !== 3).map(dose =>
                                                    <DoseContainer
                                                        key={dose.doseAplicada}
                                                        style={{ display: 'flex', flexDirection: 'column', borderWidth: 2, borderStyle: 'solid', borderColor: dose.status === 0 ? theme.vacinas.em_dia : dose.status === 1 ? theme.vacinas.proxima_dose : theme.vacinas.atrasada }}>
                                                        <span style={{ fontWeight: 'bold' }}>{vacina.doses.length === 1 ? 'Dose' : `${dose.doseAplicada}ª Dose`}</span>
                                                        <span style={{ fontSize: 11 }}>{dose.aplicacao}</span>
                                                        {dose.identificacao && <span style={{ fontSize: 11 }}>{dose.identificacao}</span>}
                                                    </DoseContainer>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </CardContainer>
                            )}
                        </>
                    }
                </div>
                <Button size='large' onClick={this.handleCancelar}>
                    <div style={{ width: '70px' }}>Voltar</div>
                </Button >

                {dosesAplicadas.length &&
                    <Button
                        size='large'
                        icon='download'
                        labelPosition="left"
                        onClick={this.downloadCarteira}
                        content='Carteira de Vacinação Digital'
                    />
                }
                <p>
                    <br />
                    <br />
                </p>
            </Segment>
        );
    }
}

function Legend() {

    function LegendItem({ label, color }) {

        return (
            <div style={{ display: "flex", flexDirection: "row", gap: 5, alignItems: 'center' }}>
                <div style={{ borderRadius: 7, height: 14, width: 14, backgroundColor: color }} />
                <span>{label}</span>
            </div>
        )
    }

    return (
        <div style={{ display: "flex", flexDirection: "row", justifyContent: 'space-around', borderRadius: 5, marginTop: 20, padding: 5, gap: 10, flexWrap: 'wrap' }}>
            <LegendItem label="Em dia" color={theme.vacinas.em_dia} />
            <LegendItem label="Próxima dose em menos de 90 dias" color={theme.vacinas.proxima_dose} />
            <LegendItem label="Atrasada" color={theme.vacinas.atrasada} />
        </div>
    )
}

function CardContainer({ children, style }) {
    return (
        <div style={{ backgroundColor: 'whitesmoke', borderRadius: 5, marginTop: 20, padding: 20, paddingTop: 10, paddingRight: 0, ...style }}>
            {children}
        </div>
    )
}

function DoseContainer({ children, style }) {
    return (
        <div style={{ borderWidth: 2, minWidth: 100, borderRadius: 5, padding: 10, ...style }}>
            {children}
        </div>
    )
}